import store from 'models/store';

const useToast = () => {
  const { setToastObject } = store.context;
  return { setToastObject };
};

export default useToast;
